import { interactionLeadLocalPart } from "@shared/utils/interactionLeadDisplay";
import type { Email } from "@src/types/api";

function outlookDelegateUserEmail(): string | undefined {
  try {
    const mailbox = Office.context?.mailbox as
      | { userProfile?: { emailAddress?: string } }
      | undefined;
    const addr = mailbox?.userProfile?.emailAddress;

    return typeof addr === "string" && addr.trim() !== "" ? addr.trim() : undefined;
  } catch {
    return undefined;
  }
}

export function resolveActorEmailForThread(email: Email | null | undefined): string | undefined {
  const lead =
    typeof email?.interactionLeadEmail === "string" && email.interactionLeadEmail.trim()
      ? email.interactionLeadEmail.trim()
      : undefined;

  return lead ?? outlookDelegateUserEmail();
}

export function statusHistoryIdentityPayload(email: Email | null | undefined): {
  actorEmail?: string;
  interactingUser?: string;
} {
  const actorEmail = resolveActorEmailForThread(email);

  if (!actorEmail) return {};
  const interactingUser = interactionLeadLocalPart(actorEmail);

  return { actorEmail, ...(interactingUser ? { interactingUser } : {}) };
}
